<page-heading [title]="(pixMode ? 'channel.templateBuilder.headingPix' : 'channel.templateBuilder.heading') | translate"
  [description]="(pixMode ? 'channel.templateBuilder.headingPixDescription' : 'channel.templateBuilder.headingDescription') | translate"
  [hasBreadcrumb]="true" [breadcrumb]="breadcrumb" />

<!-- The shared gate: 40 screens use it against 11 hand-rolled spinners. -->
@if (loading) {
<loading-component />
} @else {

<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-12 col-xl-7">
      <div class="card">
        <div class="card-body">
          <template-fields [formGroup]="formGroup" [engine]="engine" [idChannel]="idChannel"
            [editing]="editing" />
        </div>

        <div class="card-footer">
          <!-- RF-28 — every rule that blocks saving is stated before it is attempted. -->
          @if (problems.length > 0) {
          <div class="alert alert-warning py-2" role="alert">
            <ul class="mb-0 ps-3">
              @for (problem of problems; track problem.key) {
              <li class="font-13">{{ problem.key | translate:problem.params }}</li>
              }
            </ul>
          </div>
          }

          <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-light" (click)="backToList()">
              {{ 'channel.templateBuilder.cancel' | translate }}
            </button>
            <button type="button" class="btn btn-primary" [disabled]="!canSave" (click)="save()">
              @if (submitting) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
              }
              {{ 'channel.templateBuilder.submitForReview' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Stacks below the form under xl (RNF-02). -->
    <div class="col-12 col-xl-5">
      <template-preview [formGroup]="formGroup" [engine]="engine" />
    </div>
  </div>
</form>
}
